/// <amd-module name="Comments/Redux/CommentsReduxModule" />
import { commentsReducer } from "Comments/Redux/CommentsReducer";
import { rootCommentsSaga } from "Comments/Redux/CommentsSaga";
import { ICommentsReduxAwareState } from "Comments/Redux/Contracts";
import { ISagaModule } from "redux-dynamic-modules-saga";

export const CommentsReduxModule: ISagaModule<ICommentsReduxAwareState> = {
    id: "comments-redux-module",
    reducerMap: {
        commentsReduxStateMap: commentsReducer
    },
    sagas: [rootCommentsSaga]
};
